import styles from '../globals/legal.module.scss'

function Terms() {
    return (
        <div className={styles.legalPage}>
            <h1>Website Terms of Use</h1>
            <p className={styles.subtitle}>Motor Finance Claims Advice</p>
            <p className={styles.lastUpdated}>Last Updated: 16th June 2026</p>

            <h2>1. Using This Website</h2>
            <p>These Terms of Use govern your access to and use of:</p>
            <p>https://mfc-advice.sentinellegal.co.uk (&ldquo;our site&rdquo;).</p>
            <p>
                By accessing or using our site, you confirm that you accept these terms and agree to comply with them.
                If you do not agree, you must not use our site.
            </p>
            <p>
                You agree that any information you submit via this site is accurate and truthful to the best of your
                knowledge.
            </p>

            <h2>2. Information About Us</h2>
            <p>This website is operated by:</p>
            <p>
                Evans Hughes Ltd
                <br />
                Trading as Motor Finance Claims Advice
                <br />
                Company Number: 12573301
                <br />
                Registered Office: 128 City Road, London, EC1V 2NX
            </p>
            <p>
                Evans Hughes Ltd is authorised and regulated by the Financial Conduct Authority (FCA) for regulated
                claims management activities.
            </p>
            <p>Firm Reference Number: 927014</p>

            <h2>3. Nature of Our Service</h2>
            <p>Evans Hughes Ltd is an FCA-regulated Claims Management Company.</p>
            <p>We operate as:</p>
            <ul>
                <li>A regulated claims management introducer</li>
                <li>A marketing and enquiry handling service</li>
            </ul>
            <p>We are not a law firm and do not provide legal advice.</p>

            <h2>4. Introduction to Sentinel Legal Ltd or another regulated provider</h2>
            <p>
                If you ask for your motor finance claim enquiry to be assessed or referred, we may introduce you to
                Sentinel Legal Ltd, an SRA-regulated law firm, or another appropriately authorised claims management
                company or regulated legal services provider where applicable.
            </p>
            <p>
                Sentinel Legal Ltd
                <br />
                SRA Number: 811792
                <br />
                Company Number: 12826774
                <br />
                Registered Office: Harley House, 29 Cambray Place, Cheltenham, GL50 1JN
            </p>
            <p>
                Sentinel Legal Ltd is authorised and regulated by the Solicitors Regulation Authority and is authorised
                to provide legal services.
            </p>
            <p>Sentinel Legal Ltd is responsible for:</p>
            <ul>
                <li>Assessing eligibility</li>
                <li>Processing your claim</li>
                <li>Managing your claim file</li>
                <li>Handling claim-related communications</li>
                <li>Handling claim-related complaints</li>
            </ul>
            <p>
                Any contract for claim services will be directly between you and Sentinel Legal Ltd (or another
                appointed claims management firm where applicable).
            </p>
            <p>Evans Hughes Ltd is not a party to that claim services contract and is not responsible for:</p>
            <ul>
                <li>Claim handling decisions</li>
                <li>Claim outcomes</li>
                <li>Claim data storage</li>
                <li>Fees charged by the claim processor</li>
            </ul>
            <p>You are under no obligation to proceed with any firm introduced via our service.</p>
            <p>
                Before any claim is progressed, Sentinel Legal Ltd will ask whether you have already instructed another
                representative in relation to the same motor finance agreement. Sentinel Legal Ltd will only proceed
                once it is satisfied that it has your clear authority and instructions.
            </p>

            <h2>5. Fees &amp; Commercial Arrangements</h2>
            <p>
                Sentinel Legal Ltd, as an SRA-regulated law firm, or another appropriately authorised claims management
                company or regulated legal services provider, may pay Evans Hughes Ltd a marketing fee, referral fee,
                administration fee, fee share or other commercial benefit where your enquiry is referred or where your
                matter proceeds.
            </p>
            <p>This does not affect the amount you are charged.</p>
            <p>Any fees payable by you will be explained in your agreement with the claim processing firm.</p>
            <p>
                If you cancel your claim after the statutory cooling-off period, the claim processing firm may charge a
                cancellation fee in accordance with its own terms.
            </p>

            <h2>6. Geographic Scope</h2>
            <p>Our services operate in England and Wales.</p>
            <p>If your claim relates to Scotland, please contact us to discuss available options.</p>

            <h2>7. Data Protection</h2>
            <p>Your personal data is processed in accordance with our Privacy Policy.</p>
            <p>Depending on how you engage with us:</p>
            <ul>
                <li>Be Claims Ready Ltd trading as Offer Vault may act as Data Controller for initial data collection and consent.</li>
                <li>Evans Hughes Ltd acts as Data Controller for marketing and enquiry handling.</li>
                <li>Sentinel Legal Ltd acts as Data Controller for claim processing data submitted via their webform.</li>
            </ul>
            <p>Please refer to our Privacy Policy for full details.</p>

            <h2>8. No Legal Advice</h2>
            <p>The content on this website is provided for general information only.</p>
            <p>It does not constitute legal advice, financial advice, or professional advice.</p>
            <p>You should not rely solely on information provided on this website when making decisions about your claim.</p>
            <p>
                Submitting an enquiry does not guarantee that you have a valid claim, that Sentinel Legal Ltd will
                accept your matter, or that any compensation will be recovered. Any assessment will depend on the facts,
                documents, lender response, applicable law and any relevant regulatory scheme.
            </p>

            <h2>9. Access to the Website</h2>
            <p>Access to our site is provided on a temporary basis.</p>
            <p>We may:</p>
            <ul>
                <li>Withdraw or amend the site without notice</li>
                <li>Restrict access</li>
                <li>Update content at any time</li>
            </ul>
            <p>We are not liable if the site is unavailable at any time.</p>
            <p>
                You are responsible for ensuring that anyone accessing our site via your internet connection complies
                with these terms.
            </p>

            <h2>10. Intellectual Property</h2>
            <p>We own or license all intellectual property rights in this website and its content.</p>
            <p>You may:</p>
            <ul>
                <li>Print or download content for personal use only.</li>
            </ul>
            <p>You may not:</p>
            <ul>
                <li>Reproduce, modify or distribute content for commercial purposes without written permission.</li>
            </ul>

            <h2>11. Limitation of Liability</h2>
            <p>To the fullest extent permitted by law, Evans Hughes Ltd excludes liability for:</p>
            <ul>
                <li>Loss of income</li>
                <li>Loss of business or profits</li>
                <li>Loss of data</li>
                <li>Business interruption</li>
                <li>Indirect or consequential loss</li>
            </ul>
            <p>Nothing in these terms excludes liability for:</p>
            <ul>
                <li>Death or personal injury caused by negligence</li>
                <li>Fraud</li>
                <li>Any liability that cannot lawfully be excluded</li>
            </ul>
            <p>We are not responsible for:</p>
            <ul>
                <li>Decisions made in relation to your claim</li>
                <li>Fees charged by the claim processor</li>
            </ul>
            <p>
                We are not responsible for legal services provided by Sentinel Legal Ltd or any other appointed
                regulated provider. Any legal services agreement will be between you and the relevant regulated
                provider.
            </p>

            <h2>12. Viruses &amp; Misuse</h2>
            <p>You must not misuse this website by introducing viruses or attempting unauthorised access.</p>
            <p>We will report criminal misuse to law enforcement authorities.</p>
            <p>We do not accept liability for damage caused by viruses or malicious software.</p>

            <h2>13. Links to Other Websites</h2>
            <p>This website may contain links to third-party websites.</p>
            <p>We do not control and are not responsible for the content or privacy practices of those websites.</p>

            <h2>14. Jurisdiction</h2>
            <p>These Terms are governed by the laws of England and Wales.</p>
            <p>The courts of England and Wales shall have exclusive jurisdiction over any disputes.</p>

            <h2>15. Changes to These Terms</h2>
            <p>We may revise these Terms at any time by updating this page.</p>
            <p>You are expected to review these Terms periodically.</p>

            <h2>16. Complaints and Regulatory Contacts</h2>
            <p>
                Complaints about marketing, enquiry handling or claims management activity by Evans Hughes Ltd should be
                raised with Evans Hughes Ltd. If unresolved, you may be able to complain to the Financial Ombudsman
                Service. Complaints about legal services provided by Sentinel Legal Ltd should be raised with Sentinel
                Legal Ltd under its complaints procedure. You may also have rights to complain to the Legal Ombudsman or
                the Solicitors Regulation Authority depending on the nature of the complaint. Complaints or concerns
                about data protection may be raised with the relevant data controller and you may also complain to the
                Information Commissioner&rsquo;s Office.
            </p>

            <h2>17. Contact Us</h2>
            <p>If you have any questions regarding these Terms, please contact:</p>
            <p>
                Evans Hughes Ltd
                <br />
                Email: info@evanshughes.co.uk
            </p>
            <p>If your query relates to claim handling, please contact Sentinel Legal Ltd directly.</p>
        </div>
    )
}

export default Terms
